/**
 * Names on the call stage, web and native.
 *
 * On by default (Robert, 2026-09-28): every tile keeps its person's name while
 * the call controls are hidden. Settings can turn that off; names then show
 * only with the controls, as they did before.
 *
 * While the controls show, a name whose tile runs under the call bar sits just
 * above the bar, and drops back to the tile's corner when the bar hides.
 */
import { getPersistentItem } from '../vrs-auth/storage';
/** Device preference: 'false' when names show only with the call controls. */
export const CALL_NAMES_KEY = 'vrs_call_names';
/** Space between a raised name and the top of the call bar. */
export const NAME_BAR_GAP = 8;
/**
 * Whether names stay on while the call controls are hidden.
 *
 * @returns {boolean}
 */
export function callNamesAlwaysOn() {
    return getPersistentItem(CALL_NAMES_KEY) !== 'false';
}
/**
 * How far a name rises to clear the call bar: 0 when there is no bar or the
 * bar is not under it.
 *
 * @param {INameBox} name - The name where it sits in its tile's corner.
 * @param {IBarBox} [bar] - The call bar while it is showing.
 * @returns {number} Pixels to raise the name by.
 */
export function nameLift(name, bar) {
    if (!bar || bar.bottom <= bar.top || name.right <= bar.left || name.left >= bar.right) {
        return 0;
    }
    const clearLine = bar.top - NAME_BAR_GAP;
    return name.bottom > clearLine ? Math.ceil(name.bottom - clearLine) : 0;
}
